"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransportDocuments = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _TransportDocumentsPanel = require("../../components/transportdocuments/TransportDocumentsPanel");

var _TransportDocumentsPanel2 = _interopRequireDefault(_TransportDocumentsPanel);

var _reactRedux = require("react-redux");

var _reduxConnect = require("redux-connect");

var _transportDocuments = require("../../redux/modules/transportDocuments");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransportDocuments = exports.TransportDocuments = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TransportDocuments, _Component);

  function TransportDocuments() {
    (0, _classCallCheck3.default)(this, TransportDocuments);
    return (0, _possibleConstructorReturn3.default)(this, (TransportDocuments.__proto__ || (0, _getPrototypeOf2.default)(TransportDocuments)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransportDocuments, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Kuljetusraportti" }),
        _react2.default.createElement(_TransportDocumentsPanel2.default, (0, _extends3.default)({}, this.props, {
          user: this.props.auth.user,
          soilTypes: this.props.soilTypes
        }))
      );
    }
  }]);
  return TransportDocuments;
}(_react.Component), _class.propTypes = {
  auth: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  soilTypes: _react.PropTypes.array,
  transportDocuments: _react.PropTypes.array,
  loadTransportDocuments: _react.PropTypes.func.isRequired,
  ewcCodes: _react.PropTypes.array,
  loadEwcCodes: _react.PropTypes.func
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    //   if (!isTransportDocumentsLoaded(getState())) {
    promises.push(dispatch((0, _transportDocuments.loadTransportDocuments)(getState().auth.user)));
    //   }
    return _promise2.default.all(promises);
  }
}, {
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState;

    var promises = [];

    if (!(0, _transportDocuments.isEwcCodesLoaded)(getState())) {
      promises.push(dispatch((0, _transportDocuments.loadEwcCodes)()));
    }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    transportDocuments: state.transportDocuments.transportDocuments,
    auth: state.auth,
    soilTypes: state.ads.soilTypes,
    ewcCodes: state.transportDocuments.ewcCodes
  };
}, {
  loadTransportDocuments: _transportDocuments.loadTransportDocuments
})(TransportDocuments));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/TransportDocuments/TransportDocuments.js
 ** module id = 1246
 ** module chunks = 0
 **/